module.exports = "<div class=\"resource-item-content product-reel-item\">\r\n  \r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/placeholder-reel-item.html
// module id = 388
// module chunks = 1